import React, { useState } from 'react';
import { extractVideoId, getThumbnailUrl, isValidYouTubeUrl } from '../utils/youtubeUtils';
import '../styles/YouTubeExtractor.css';

const YouTubeExtractor = ({ onThumbnailExtracted }) => {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleExtract = async (e) => {
    e.preventDefault();
    
    if (!url.trim()) {
      setError('Please enter a YouTube URL');
      return;
    }

    if (!isValidYouTubeUrl(url)) {
      setError('Please enter a valid YouTube URL');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const videoId = extractVideoId(url);
      const thumbnailUrl = getThumbnailUrl(videoId);
      
      // Test if thumbnail exists
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      img.onload = () => {
        setLoading(false);
        onThumbnailExtracted({
          videoId,
          thumbnailUrl,
          originalUrl: url,
        });
      };
      
      img.onerror = () => {
        setLoading(false);
        setError('Could not load thumbnail from this video. Please try another URL.');
      };
      
      img.src = thumbnailUrl;
      
    } catch (err) {
      setLoading(false);
      setError('Failed to extract thumbnail. Please try again.');
      console.error('Extraction error:', err);
    }
  };

  const handleUrlChange = (e) => {
    setUrl(e.target.value);
    if (error) setError('');
  };

  return (
    <div className="youtube-extractor component-card">
      <h2>Step 1: Extract YouTube Thumbnail</h2>
      <form onSubmit={handleExtract} className="extractor-form">
        <div className="input-group">
          <input
            type="url"
            value={url}
            onChange={handleUrlChange}
            placeholder="Enter YouTube URL (e.g., https://www.youtube.com/watch?v=...)"
            className={`url-input ${error ? 'error' : ''}`}
            disabled={loading}
          />
          <button 
            type="submit" 
            className="extract-btn"
            disabled={loading || !url.trim()}
          >
            {loading ? 'Extracting...' : 'Extract Thumbnail'}
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
      </form>
      
      <div className="help-text">
        <p>📹 Paste a YouTube video URL to extract its thumbnail image</p>
        <p>This will be the base for your AI-generated podcast thumbnail</p>
      </div>
    </div>
  );
};

export default YouTubeExtractor;
